import { render, staticRenderFns } from "./CouponsCard.vue?vue&type=template&id=e4198956&scoped=true&"
import script from "./CouponsCard.vue?vue&type=script&lang=js&"
export * from "./CouponsCard.vue?vue&type=script&lang=js&"
import style0 from "./CouponsCard.vue?vue&type=style&index=0&id=e4198956&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4198956",
  null
  
)

export default component.exports